import styled from 'styled-components/macro';

export const CircleLoaderStyled = styled.div`
  width: 100px;
  height: 100px;
  border: ${({ theme }) => `${theme.borders['5xl']} ${theme.colors.white}`};
  border-top: ${({ theme }) => `${theme.borders['5xl']} ${theme.colors.primary.variant1}`};
  border-bottom: ${({ theme }) => `${theme.borders['5xl']} ${theme.colors.primary.variant1}`};
  border-radius: ${({ theme }) => theme.radius.half};
  animation: spin 1.1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
